module.exports = __webpack_public_path__ + "img/birthday-cake-img.93c2c35a.webp";